<template>
    <!-- max-width="374" -->
    <v-card :disabled="loading" variant="flat" :loading="loading" rounded="0" class="custom-news-card">
        <v-card-item class="pa-2">
            <v-menu v-if="editable" location="bottom end">
                <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" icon="mdi-chevron-down"
                        style="position:absolute; right: 5px; z-index: 1000"></v-icon>
                </template>
                <v-list>
                    <v-list-item @click="null">
                        <v-list-item-title @click="editPost">{{ $t('edit') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="() => openConfirmationDialog(item)">
                        <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-list-item class="w-100 text-left px-0">
                <template v-slot:prepend>
                    <v-avatar color="grey-darken-3" rounded="0" size="50"
                        :image="`${cloudfrontUrl}${item.shop ? item?.shop.avatar : item?.user.avatar }/AVATAR`" class="clickable"
                        @click="editable ? null : item.shop ? $router.push({ path: `/${selectedArea.urlName}/laden/${item?.shop?.urlname}`, query: { mode: 'all', lang: selectedLanguage.toUpperCase() } }) : openDownloadAppHint()"></v-avatar>
                </template>
                <v-list-item-title
                    @click="editable ? null : item.shop ? $router.push({ path: `/${selectedArea.urlName}/laden/${item?.shop?.urlname}`, query: { mode: 'all', lang: selectedLanguage.toUpperCase() } }) : openDownloadAppHint()"
                    class="mb-2 clickable">{{ item.shop ?item.shop?.name : item.user?.username }}</v-list-item-title>


                <v-list-item-subtitle>{{ item.shop ? item.shop?.tagline : item.user.profile['fields']?.bio?.value  }}</v-list-item-subtitle>
            </v-list-item>
        </v-card-item>
        <v-card-text @click="openPostPopup" class="clickable">
            <div class="news-post-info text-right">
                <!-- <span class=" d-inline-block float-left" style="font-size: 10px"> {{ $t(item.category) }} </span> -->
                <span class="post-start d-inline-block">{{ $getTimeDuration(item.publishedAt) }}</span>
            </div>
            <h6
                @click.stop="item.shop ? $router.push({ path: `/${selectedArea.urlName}/laden/${item?.shop?.urlname}/neuigkeiten/${item.urlName}`, query: { mode: 'all', lang: selectedLanguage.toUpperCase() } }) : $router.push({ path: `/${selectedArea.urlName}/user/${item?.user?.username}/neuigkeiten/${item.urlName}`, query: { mode: 'all', lang: selectedLanguage.toUpperCase() } })">
                {{ item.headline }}</h6>
            <span>
                <!-- {{ item }} -->
                {{ !item.text ? '' : item.text?.slice(0, 120) + '...' }} <a
                    v-if="item.text?.length > 120 && item.text?.length != 0 && item.text != ''">{{ $t('main.more') }} </a>
            </span>
        </v-card-text>
        <v-responsive class="d-flex align-items-center clickable" @click="openPostPopup">
            <v-img :src="`${cloudfrontUrl}${img}/STREAM`" class="full-width">
                <span class="text-white multiple-image-hint"
                    v-if="Array.isArray(item.images) && item.images.length > 1">
                    {{$t('global.more-images.multiple', {num:item?.images.length - 1})}} </span>
            </v-img>
        </v-responsive>
        <div class="stream-action-bar pa-2 clickable"
            v-if="[typeof item.impressionCount] != 'undefined' && item.impressionCount != null" @click="openPostPopup">
            <v-tooltip activator="parent" location="end top">
                <div class="">
                    <span style="font-size: 11px">
                        {{$t('shop.stream.actionBar.tooltip')}}
                    </span>
                </div>
                <template v-slot:activator="{ props }">
                    <div v-bind="props" class="d-inline-flex align-items-center w-auto">
                        <v-icon class="mr-2">mdi-eye</v-icon>
                        <span>{{ item?.impressionCount }}</span>
                    </div>
                </template>
            </v-tooltip>
        </div>
    </v-card>
</template>

<script>
import { getCurrentInstance, inject, ref } from 'vue'
export default {

    props: {
        img: {
            type: String,
            default: null
        },
        title: {
            type: String,
            required: true
        },
        openPostPopup: {
            type: Function,
        },
        item: {
            type: Object,
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    emits: ['delete-news'],
    setup(props, { emit }) {
        const selectedArea = inject("selectedArea")
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const editObj = ref({});
        const { proxy } = getCurrentInstance();

        const createShopNews = inject('createShopNews');

        // const emit = defineEmits(['delete-news'])
        const openDownloadAppHint = inject('openDownloadAppHint')
        const openConfirmationDialog = (item) => {
            emit('delete-news', item.id)
        }

        const editPost = async () => {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            const softToken = localStorage.getItem("softToken");
            try {
                const response = await proxy.$axios.get(`/stream/dealer/${props.item.id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                if (response.data.status == "OK") {
                    editObj.value = response.data.data || [];
                }

            } catch (error) {
                console.error("Error fetching search results:", error);
            } finally {
                // loading.value = false;
                if (createShopNews) {
                    createShopNews(editObj.value)
                }

            }
        }

        return {
            selectedLanguage,
            selectedArea,
            editPost,
            openConfirmationDialog,
            openDownloadAppHint
        }
    },

    data() {
        return {
            cloudfrontUrl: process.env.VUE_APP_CLOUDFRONT_BASE_URL,
            imageSrc: "https://picsum.photos/id/237/200/300", // You can replace with the actual image URL
        };
    },
};
</script>

<style scoped>
.stream-action-bar {
    background-color: #F5F5F5;
}

.card-container {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    padding: 16px;
}

.title {
    font-weight: bold;
    font-size: 18px;
}

.card-image {
    border-radius: 10px;
}

.card-subtitle {
    font-size: 14px;
    color: #6c757d;
    padding: 0 16px;
}

.card-actions {
    display: flex;
    justify-content: space-between;
    padding: 8px 16px;
}

.chip {
    margin-right: 8px;
}
</style>

<style>
.custom-news-card {}

.multiple-image-hint {
    position: absolute;
    right: 5px;
    bottom: 15px;
}

.custom-news-card .v-card-item {
    background-color: #ededed;
}

.custom-news-card .v-card-text {
    background-color: #F5F5F5;
}

.custom-news-card .v-card-text .news-post-info .post-start {
    text-align: right;
    display: block;
    font-size: 12px;
    font-weight: 300;
}

.clickable {
    cursor: pointer;
}
</style>